module.exports = __webpack_public_path__ + "static/media/degen.700339b8.png";